import { Injectable } from '@angular/core';
import {ExError,ErrorType} from './error'
import {Logger, Options, Level } from "angular2-logger/core"; // ADD THIS

@Injectable()
export class ErrorService {

  private type:ErrorType
  private logger : Logger = new Logger();
  constructor() {  
    this.type = ErrorType.console;
  }
  public setType(type:ErrorType)  {
    this.type = type;
  }

  handle(err:ExError):void{    
    switch(this.type){
      case ErrorType.console:
        this.console(err) ;
      break;
      case ErrorType.alret:
        this.alret(err) ;
      break;
      default:
        this.console(err) ;
      break;
    }
    
  }
  console(err:any):void{
      this.logger.error(err);
  }
  alret(err:any):void{
    //
  }
}



// WEBPACK FOOTER //
// ./src/app/error/error.service.ts